import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { CompanyAddressService } from '../_services';
import * as CompanyAddressActions from '../_actions/companyAddress';

@Injectable({
  providedIn: 'root',
})
export class CompanyAddressEffects {
  loadCompanyAddresses$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CompanyAddressActions.loadCompanyAddresses),
      mergeMap(() =>
        this.companyAddressService.getCompanyAddresses().pipe(
          map((companyAddresses) =>
            CompanyAddressActions.loadCompanyAddressesSuccess({ companyAddresses })
          ),
          catchError((error) => of(CompanyAddressActions.loadCompanyAddressesFailure({ error })))
        )
      )
    )
  );

  addCompanyAddress$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CompanyAddressActions.addCompanyAddress),
      mergeMap(({ companyAddress }) =>
        this.companyAddressService.saveCompanyAddress(companyAddress).pipe(
          map((savedCompanyAddress) =>
            CompanyAddressActions.addCompanyAddressSuccess({ companyAddress: savedCompanyAddress })
          ),
          catchError((error) => of(CompanyAddressActions.addCompanyAddressFailure({ error })))
        )
      )
    )
  );

  updateCompanyAddress$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CompanyAddressActions.updateCompanyAddress),
      mergeMap(({ companyAddress }) =>
        this.companyAddressService.saveCompanyAddress(companyAddress).pipe(
          map((updatedCompanyAddress) =>
            CompanyAddressActions.updateCompanyAddressSuccess({
              companyAddress: updatedCompanyAddress,
            })
          ),
          catchError((error) => of(CompanyAddressActions.updateCompanyAddressFailure({ error })))
        )
      )
    )
  );

  deleteCompanyAddress$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CompanyAddressActions.deleteCompanyAddress),
      mergeMap(({ id }) =>
        this.companyAddressService.deleteCompanyAddress(id).pipe(
          map(() => CompanyAddressActions.deleteCompanyAddressSuccess({ id })),
          catchError((error) => of(CompanyAddressActions.deleteCompanyAddressFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private companyAddressService: CompanyAddressService
  ) {}
}
